import React from 'react';
import { Button } from '@ebay-certilogo/design-system-web';

function Link(props) {
  return <Button buttonType="link" arrow={false} {...props} />;
}

export default Link;
